import React, { useEffect, useRef, useState } from "react";
import { Box } from "lucide-react";

const KEY = "itp_3d";
export const get3D = () => localStorage.getItem(KEY) !== "0";

export function Toggle3D({ on, setOn, className = "" }) {
  return (
    <button onClick={() => { const v = !on; localStorage.setItem(KEY, v ? "1" : "0"); setOn(v); }} data-testid="toggle-3d" title="3D workspace"
      className={`h-8 px-2.5 rounded border border-black text-xs flex items-center gap-1.5 transition-colors ${on ? "bg-amber-400 text-black" : "bg-[#1d1f23] text-zinc-300 hover:text-white hover:bg-[#30333a]"} ${className}`}>
      <Box className="w-3.5 h-3.5" />3D
    </button>
  );
}

export default function Stage3D({ on, children, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !on) return;
    let raf = 0, px = 0, py = 0;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      px = ((e.clientX - r.left) / r.width - 0.5) * 2; py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(() => { raf = 0; el.style.setProperty("--px", px.toFixed(3)); el.style.setProperty("--py", py.toFixed(3)); });
    };
    const leave = () => { el.style.setProperty("--px", "0"); el.style.setProperty("--py", "0"); };
    el.addEventListener("pointermove", move); el.addEventListener("pointerleave", leave);
    return () => { el.removeEventListener("pointermove", move); el.removeEventListener("pointerleave", leave); cancelAnimationFrame(raf); };
  }, [on]);
  return (
    <div ref={ref} className={`stage3d h-full ${on ? "is-3d" : ""} ${className}`} data-testid="stage-3d" data-on={on ? "1" : "0"}>
      <div className="stage3d-plane h-full">{children}</div>
    </div>
  );
}

export function use3D() {
  const [on, setOn] = useState(get3D);
  return [on, setOn];
}
